import React from "react"
import { Link } from "react-router-dom"

import { GetStartedButton } from "components/marketing/get-started-button"
import { BrowserView, MobileView } from "components/helpers/hide"
import { H3, Paragraph, ParagraphSmall } from "components/text"
import { RoundImage } from "components/image"
import Grid, { Col } from "components/grid"
import { Flex, Box } from "components/box"
import { LoadingWrapper } from "components/loading-wrapper"

import { getFormatDiscountPrice } from "shared/products/helpers"
import { useRootQuery } from "graphql/smart-queries/user"
import { baseRoutes } from "routes"

import DrCrystal from "assets/doctors/dr-crystal@2x.png"

export const OngoingSupport: React.FC = () => {
  const { data, loading, error } = useRootQuery()

  const discount =
    data?.currentOffer?.discountPercentage &&
    getFormatDiscountPrice({ discountPercentage: data.currentOffer.discountPercentage, withPercent: true })

  return (
    <Grid>
      <Col cols={[4, 4, 4, 4]} push={[0, 0, 2, 2]}>
        <H3 py={5} mb={1}>
          Connect with one of our most trusted headache experts
        </H3>
        <LoadingWrapper loading={loading} error={error}>
          <Paragraph mb={["2rem", null, 3]}>
            Complete your online consultation today to get {discount} off your first month of Cove.
          </Paragraph>
        </LoadingWrapper>
        <BrowserView>
          <GetStartedButton sizing="lg" />
        </BrowserView>
      </Col>
      <Col cols={[4, 4, 4, 4]} textAlign="center">
        <Link to={baseRoutes.choosePlan()}>
          <Flex alignItems="center" justifyContent="center">
            <Box width={["230px", null, "100%"]}>
              <RoundImage pl={[3, 3]} src={DrCrystal} />
            </Box>
          </Flex>
        </Link>
        <Paragraph bold color="charcoal" mt={["1.188rem", null, "1.563rem"]}>
          Dr. Sara Crystal, MD
        </Paragraph>
        <Flex alignItems="center" justifyContent="center">
          <Box width={["100%", null, "11.438rem"]}>
            <ParagraphSmall mb={["1.25rem"]}>Neurologist, Cove Medical Director</ParagraphSmall>
          </Box>
        </Flex>
      </Col>
      <Col cols={[4, 4, 12, 12]}>
        <MobileView>
          <GetStartedButton />
        </MobileView>
      </Col>
    </Grid>
  )
}
